export default {
    "results": {
        "missingTerms": "fehlende Begriffe:",
        "resultsCount": "{count, plural, =0 {keine Ergebnisse} one {# Ergebnis} other {# Ergebnisse}}"
    },
    "userRatings": {
        "average": "Durchschnittlich: {average}"
    },
};
